import { render, staticRenderFns } from "./treasure-upgrade.vue?vue&type=template&id=5df20db8&scoped=true&"
import script from "./treasure-upgrade.vue?vue&type=script&lang=js&"
export * from "./treasure-upgrade.vue?vue&type=script&lang=js&"
import style0 from "./treasure-upgrade.vue?vue&type=style&index=0&id=5df20db8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df20db8",
  null
  
)

export default component.exports